var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCode3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 71,
    height: 70,
    viewBox: "0 0 71 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1896_3558)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.5 0H70.5V70H0.5V0Z",
    fill: "#F7DF1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.9065 58.4962L24.2632 55.2543C25.2968 57.0866 26.2368 58.637 28.4919 58.637C30.6534 58.637 32.0165 57.7916 32.0165 54.5027V32.136H38.5946V54.5956C38.5946 61.4089 34.6007 64.5102 28.7738 64.5102C23.5115 64.5102 20.4569 61.7848 18.9062 58.4957M42.1676 57.7913L47.5237 54.6902C48.9338 56.9929 50.7664 58.6843 54.0082 58.6843C56.7341 58.6843 58.4721 57.3215 58.4721 55.4419C58.4721 53.1866 56.6866 52.3876 53.6793 51.0724L52.0351 50.3669C47.2891 48.347 44.141 45.8095 44.141 40.4529C44.141 35.519 47.8999 31.7598 53.7736 31.7598C57.9556 31.7598 60.9629 33.2166 63.1241 37.0226L58.0021 40.3121C56.8741 38.2916 55.653 37.4929 53.7734 37.4929C51.8467 37.4929 50.625 38.7146 50.625 40.3121C50.625 42.2855 51.8467 43.0847 54.6659 44.3064L56.3103 45.0111C61.9021 47.4078 65.0502 49.8509 65.0502 55.3481C65.0502 61.2691 60.3985 64.511 54.1491 64.511C48.0407 64.511 44.0937 61.5978 42.1673 57.7916",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1896_3558"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 70,
    height: 70,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCode3);
export default __webpack_public_path__ + "static/media/code3.8d57cbe108e044be68dc31bca4ac88ed.svg";
export { ForwardRef as ReactComponent };